import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { EventConfigProvider } from './hooks/useEventConfig';
import { CustomThemeProvider } from './theme/ThemeProvider';

const RootComponent: React.FC = () => {
  useEffect(() => {
    // Desativa o botão direito do mouse
    const disableContextMenu = (event: Event) => event.preventDefault();
    document.addEventListener("contextmenu", disableContextMenu);

    // Impede zoom por atalho do teclado
    const disableZoomKeys = (event: KeyboardEvent) => {
      if (
        event.ctrlKey &&
        (event.key === "=" || event.key === "-" || event.key === "0")
      ) {
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", disableZoomKeys);

    // Impede zoom por gestos de pinça no touch
    const disableGesture = (event: Event) => event.preventDefault();
    document.addEventListener("gesturestart", disableGesture);
    document.addEventListener("gesturechange", disableGesture);

    // Bloqueia toques longos para evitar pop-ups do navegador
    const disableLongPress = (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };
    document.addEventListener("touchstart", disableLongPress);
    document.addEventListener("touchmove", disableLongPress);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("keydown", disableZoomKeys);
      document.removeEventListener("gesturestart", disableGesture);
      document.removeEventListener("gesturechange", disableGesture);
      document.removeEventListener("touchstart", disableLongPress);
      document.removeEventListener("touchmove", disableLongPress);
    };
  }, []);

  return (
    <CustomThemeProvider>
      {/* A identidade visual do evento vem da API e é cacheada localmente, então a
          primeira pintura já sai com as cores certas mesmo sem rede. */}
      <EventConfigProvider>
        <App />
      </EventConfigProvider>
    </CustomThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);
